export default __webpack_public_path__ + "static/media/AetherPhoto4.6b9fd2a1.jpg";